import React, { Component } from 'react';
import fetch from 'cross-fetch';
import PropTypes from 'prop-types';

import { withTranslation } from 'react-i18next';
import NavBar, { NextButton, BackButton } from './NavBar2.jsx';

class AmazonVineFinalizeForm extends Component {
  state = {
    isLoading: false,
    errorCode: null,
  };

  handleSubmit = () => {
    const { onNext } = this.props;
    const { deviceEmei, validatedPromoCode } = this.props.values;

    this.setState({ isLoading: true });

    this.activateDevice(deviceEmei, validatedPromoCode)
      .then((activateJson) => {
        this.setState({ isLoading: false });
        onNext({ devicePlatform: activateJson.devicePlatform });
      })
      .catch((e) => {
        this.setState({
          isLoading: false,
          errorCode: e,
        });
      });
  };

  activateDevice = (deviceEmei, promoCode) => fetch('/sessions/me/activate-device', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      deviceEmei,
      promoCode,
    }),
  })
    .then((response) => {
      if (!response.ok) {
        // TODO: Need more informative error
        throw new Error('Failed to activate device');
      }

      return response.json();
    });

  render() {
    const { onBack, t } = this.props;

    return (
      <div>
        <h2>{t('vine_complete_form.title')}</h2>
        <div className="form-group">
          <p className="form-text text-muted">
            {t('vine_complete_form.paragraph_1')}
          </p>
          <p className="form-text text-muted">
            {t('vine_complete_form.paragraph_2')}
          </p>
        </div>

      <NavBar>
          <NextButton
            isLoading={this.state.isLoading}
            onClick={this.handleSubmit}
            label={t('vine_complete_form.button_label')}
          />
          <BackButton onClick={onBack} />
      </NavBar>
      </div>
    );
  }
}

AmazonVineFinalizeForm.propTypes = {
  onNext: PropTypes.func,
  onBack: PropTypes.func,
  handleChange: PropTypes.func,
  values: PropTypes.object,
};


export default withTranslation('activation_wizard')(AmazonVineFinalizeForm);
